import { type BACKGROUND_COLORS_VALUES, COLORS } from '@alto/design-library-tokens';
import { isFuzeRxBrand } from './getBrand';

/**
 * FuzeRx surfaces (PH-4256).
 *
 * The Fuze color system was mapped onto the existing tokens one-for-one, which left FuzeRx painting
 * neutral chrome — page sections, hovered rows, selected options — with brand-tinted greens. Design's
 * rule is that on FuzeRx those surfaces are warm greys, and colour is reserved for states that mean
 * something (warning, danger, success). Alto and Fuze Health keep their tinted surfaces.
 *
 * Each helper is a function rather than a constant because `COLORS` is swapped at runtime when the
 * brand resolves; reading it at module load would capture the wrong palette.
 */

/** A neutral page or section surface that the other brands paint with a brand tint. */
export const resolveNeutralSurfaceColor = <T extends BACKGROUND_COLORS_VALUES>(
  brandTint: T,
): T | BACKGROUND_COLORS_VALUES => (isFuzeRxBrand() ? COLORS.BACKGROUND_COLORS.GREY_LIGHTEST : brandTint);

/** Background of a clickable row while hovered or pressed (`ListItem`, `ListHeader`, nav rows). */
export const getInteractiveSurfaceColor = (): BACKGROUND_COLORS_VALUES =>
  isFuzeRxBrand() ? COLORS.BACKGROUND_COLORS.GREY_LIGHTEST : COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTEST;

/** Background of a selected row (a checked radio option, an active list item). */
export const getSelectedSurfaceColor = (): BACKGROUND_COLORS_VALUES =>
  isFuzeRxBrand() ? COLORS.BACKGROUND_COLORS.GREY : COLORS.BACKGROUND_COLORS.PRIMARY_LIGHTER;
